import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { useIntl, navigate } from "gatsby-plugin-intl";
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import get from "lodash/get";
import Slider from "react-slick";

import KCArrowControls from "Components/common/kcArrowControls";

const StyledWrapper = styled.div`
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  padding: 2rem 0rem;
  display: flex;
  flex-direction: column;
`;

const StyledPhotoPost = styled.div`
  margin-left: 0.5rem;
  width: calc(100% - 0.5rem) !important;
  outline: none;
  &:first-of-type {
    margin-left: 1rem;
  }
`;

const StyledHeader = styled.div`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-box: content-box;
  width: 100%;
`;

const StyledTitle = styled.div`
  font-weight: 600;
  font-size: 2rem;
  text-align: left;
  line-height: 1.8rem;
`;

const StyledCarousel = styled(Slider)`
  width: 100%;
  margin-top: 1rem;
  & .slick-list {
    padding: 0 20% 0 0;
  }
`;

const StyledImageWrapper = styled.div`
  height: 18rem;
  overflow: hidden;
`;

const PhotoPost = ({ photo }) => {
  return (
    <StyledPhotoPost>
      <StyledImageWrapper>
        {photo && (
          <GatsbyImage
            style={{ width: "100%", height: "100%" }}
            objectFit="cover"
            image={getImage(photo.imageFile)}
            alt="photo"
          />
        )}
      </StyledImageWrapper>
    </StyledPhotoPost>
  );
};

const ScrollSettings = {
  slidesToShow: 3.5,
  speed: 500,
  infinite: false,
  arrows: false,
  touchMove: true,
  accessibility: true,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
      },
    },
  ],
};

export default function SocialModal({
  title,
  photos,
  textColor,
  backgroundColor,
}) {
  const intl = useIntl();

  const [slideIndex, setSlideIndex] = useState(0);
  const scrollWrapperRef = useRef(null);
  const handleNext = () => {
    let pageSize = window.innerWidth > 600 ? 3 : 1;
    scrollWrapperRef.current.slickGoTo(slideIndex + pageSize);
  };

  const handlePrevious = () => {
    let pageSize = window.innerWidth > 600 ? 3 : 1;
    scrollWrapperRef.current.slickGoTo(slideIndex - pageSize);
  };

  return photos.length > 0 ? (
    <StyledWrapper backgroundColor={backgroundColor}>
      <StyledHeader>
        <StyledTitle>{get(title, intl.locale, "")}</StyledTitle>
        <KCArrowControls
          slideIndex={slideIndex}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          totalSlides={photos.length - 3}
        />
      </StyledHeader>
      <StyledCarousel
        ref={scrollWrapperRef}
        {...ScrollSettings}
        beforeChange={(oldI, newI) => {
          setSlideIndex(newI);
        }}
      >
        {photos.map((photo, i) => (
          <PhotoPost key={`photocarousel${i}`} photo={photo} />
        ))}
      </StyledCarousel>
    </StyledWrapper>
  ) : (
    <></>
  );
}

export const query = graphql`
  fragment photoCarousel on STRAPI_ComponentBasePhotoCarousel {
    __typename
    id
    title {
      en
      es
      it
    }
    backgroundColor {
      color
    }
    textColor {
      color
    }
    photos {
      url
      imageFile {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            formats: AUTO
          )
        }
      }
    }
  }
`;
